/**
 * Collection of cookie names used throughout the project.
 */
export const COOKIES = {
  accessToken: 'access_token',
  adminAccessToken: 'admin_access_token',
  ajsAnonymousId: 'ajs_anonymous_id',
  appDownloadBannerDismissed: 'app_download_banner_dismissed',
  appDownloadCardDismissed: 'app_download_card_dismissed',
  appDownloadInactive: 'app_download_inactive_dismissed',
  appDownloadLoggedIn: 'app_download_logged_in_dismissed',
  automatedTest: 'automated-test',
  canadaBanner: 'canada-banner',
  capabilities: 'capabilities',
  chatTranslated: 'chatTranslated',
  clickIds: 'rvz_click_ids',
  datadog: '_dd_s',
  dismissPushNotificationsPrompt: 'dismiss_push_notification_prompt',
  experimentOverrides: 'experiment_overrides',
  gid: '_gid',
  highlightBanner: 'highlight-banner-version-',
  hostMessageTemplatesTourChat: 'hostMessageTemplatesTourChat',
  hostMessageTemplatesTourInbox: 'hostMessageTemplatesTourInbox',
  motorhomeDiscountBanner: 'motorhome-discount-banner',
  pendingRequestToBookUrl: 'pending-request-to-book-url',
  platform: 'platform',
  requestToBookStep: 'request-to-book-step',
  risAuthType: 'ris-auth-type',
  risIntent: 'ris-intent',
  risProvider: 'ris-provider',
  risRedirect: 'ris-redirect',
  searchHelpPopoverDismissed: 'search_help_popover_dismissed',
  searchHelpWizard: 'search_help_wizard',
  searchLocation: 'search_location',
  searchWizard: 'search_wizard',
  session: 'rtsessionid',
  state: 'state',
  travelTrailerDiscountBanner: 'travel-trailer-discount-banner',
  unauthorizedRedirect: 'unauthorized-redirect',
  upgradeBrowser: 'upgrade-browser',
  upsellBundle: 'upsellBundle',
  userEmail: 'user_email',
  utmParameters: 'utm_parameters',
} as const
Object.freeze(COOKIES)
export type COOKIES = (typeof COOKIES)[keyof typeof COOKIES]
